module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"FunctionalOverheadCategories\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional-overhead-categories/functional-overhead-categories.component.html
// module id = ./src/app/functional-overhead-categories/functional-overhead-categories.component.html
// module chunks = main